module.exports = __webpack_public_path__ + "img/seo_glotto_item04.c6c7163.webp";